import { render } from "./transition_fade.vue?vue&type=template&id=467df776"
import script from "./transition_fade.vue?vue&type=script&lang=js"
export * from "./transition_fade.vue?vue&type=script&lang=js"

import "./transition_fade.vue?vue&type=style&index=0&id=467df776&lang=css"

import exportComponent from "/build/9647e414-6daa-46b0-8fd7-b2edfb8f7f7d/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__